export const DATE_FORMAT_INDONESIA = 'DD MMMM YYYY'
